var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCkGreyRightArrow = function SvgCkGreyRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.5625,
    r: 24,
    fill: "#05141F",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 19.2291L23.06 20.1691L26.78 23.8958H18.6667V25.2291H26.78L23.06 28.9558L24 29.8958L29.3333 24.5625L24 19.2291Z",
    fill: "white"
  })));
};
export { SvgCkGreyRightArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA0OCA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNC41NjI1IiByPSIyNCIgZmlsbD0iIzA1MTQxRiIgZmlsbC1vcGFjaXR5PSIwLjQiLz4KPHBhdGggZD0iTTI0IDE5LjIyOTFMMjMuMDYgMjAuMTY5MUwyNi43OCAyMy44OTU4SDE4LjY2NjdWMjUuMjI5MUgyNi43OEwyMy4wNiAyOC45NTU4TDI0IDI5Ljg5NThMMjkuMzMzMyAyNC41NjI1TDI0IDE5LjIyOTFaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";